import { Paper, Typography, Box } from '@mui/material';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell, LabelList,
} from 'recharts';

const SalesmanBarChart = ({ title, icon, data, dataKey, valueFn, color, formatter }) => {
  const sorted = [...data]
    .map((row) => ({
      name: row.salesmanName,
      value: valueFn ? valueFn(row) : (Number(row[dataKey]) || 0),
    }))
    .sort((a, b) => b.value - a.value)
    .filter((row) => row.value > 0);

  const fmt = formatter || ((v) => v);
  const chartHeight = Math.max(250, sorted.length * 48 + 60);

  return (
    <Paper sx={{ p: 2.5, mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        {icon}
        <Typography variant="h6" sx={{ fontWeight: 600, color: '#0d3c61', ml: icon ? 1 : 0 }}>{title}</Typography>
      </Box>
      {sorted.length === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
          No data available
        </Typography>
      ) : (
        <ResponsiveContainer width="100%" height={chartHeight}>
          <BarChart data={sorted} layout="vertical" margin={{ left: 20, right: 40, top: 5, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" horizontal={false} />
            <XAxis type="number" tickFormatter={fmt} fontSize={11} />
            <YAxis type="category" dataKey="name" width={130} fontSize={12} tick={{ fontWeight: 600 }} />
            <Tooltip formatter={(v) => fmt(v)} />
            <Bar dataKey="value" radius={[0, 4, 4, 0]} barSize={28}>
              {sorted.map((_, i) => (
                <Cell key={i} fill={i === 0 ? color : `${color}cc`} />
              ))}
              <LabelList dataKey="value" position="right" formatter={fmt} style={{ fontWeight: 700, fontSize: 12, fill: '#333' }} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </Paper>
  );
};

export default SalesmanBarChart;
